/**
 * Category Type Definitions
 * 
 * TypeScript interfaces and enums for the Categorisation Management feature
 * Following the data model from the specification
 */

export enum CategoryType {
  INCOME = 'income',
  EXPENSE = 'expense',
  TRANSFER = 'transfer'
}

export interface Category {
  id: string;
  userId: string;
  parentId?: string;
  name: string;
  type: CategoryType;
  color?: string;
  icon?: string;
  excludeFromSpending: boolean;
  isSystem: boolean;
  gstApplicable: boolean;
  deductible: boolean;
  slug?: string;
  note?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCategoryInput {
  name: string;
  type: CategoryType;
  parentId?: string;
  color?: string;
  icon?: string;
  excludeFromSpending?: boolean;
  gstApplicable?: boolean;
  deductible?: boolean;
  note?: string;
}

export interface UpdateCategoryInput {
  name?: string;
  type?: CategoryType;
  parentId?: string;
  color?: string;
  icon?: string;
  excludeFromSpending?: boolean;
  gstApplicable?: boolean;
  deductible?: boolean;
  note?: string;
}

export interface CategoryListParams {
  type?: CategoryType | CategoryType[]; // Support single type or array of types
  parentId?: string;
  search?: string;
  includeSystem?: boolean;
  excludeFromSpending?: boolean;
}

export interface CategoryListResponse {
  categories: Category[];
  total: number;
}

